/**
 * Interface for the Whisper API that will be exposed at window level
 */

export const getWhisper = () => {
  return window.Whisper;
};